import { useContext } from "react";
import { ProductImageDetailsRootScreenContext } from "./context";

export const useProductImageDetailsRootScreenProvider = () => {
  const c = useContext(ProductImageDetailsRootScreenContext);
  if (!c)
    throw new Error(
      "useProductImageDetailsRootScreenProvider must be used within a ProductImageDetailsRootScreenProvider"
    );
  return c;
};
